/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type InternalGetMetricDiagnosticPathParams = NonNullable<
  operations['internalGetMetricDiagnostic']['parameters']['path']
>;

export interface Input extends InternalGetMetricDiagnosticPathParams {
  apiVersion?: string;
}

export async function internalGetMetricDiagnostic(
  { apiVersion, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/projects/{projectKey}/environments/{envKey}/metrics/{metricKey}/diagnostics', {
    params: { path },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
